<template>
  <div class="centerCon">
    <div class="centerTop">
      <div class="line"></div>
      <div class="lineText">全部功能</div>
      <div class="btnCon" v-for="(item, index) in btnList" :key="index" @click="gotoOther(item.key)">
        <div class="imgCon">
          <img class="imgShow" :src="item.imgSrc" alt="" />
        </div>
        <div class="btnText">{{ item.name }}</div>
      </div>
    </div>

    <div class="centerBottom">
      <div class="line"></div>
      <div class="lineText">设备列表</div>
      <div class="equipSearchContent">
        <span class="searchInputText">设备名称</span>
        <el-input placeholder="请输入设备名称" v-model="search.name"></el-input>
        <span class="searchInputText">设备编号</span>
        <el-input placeholder="请输入设备编号" v-model="search.code"></el-input>
        <span class="searchInputText">设备类型</span>
        <el-select v-model="search.type" placeholder="请选择设备类型">
          <el-option v-for="item in equipTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <span class="searchInputText">设备状态</span>
        <el-select v-model="search.status" placeholder="请选择设备状态">
          <el-option v-for="item in equipStatusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <span class="searchInputText">异常设备</span>
        <el-select v-model="search.alarmSortType" placeholder="请选择设备状态">
          <el-option v-for="item in errorList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <!-- <span class="searchInputText">所属组织</span>
        <el-input
          class="shotType"
          v-model="search.officeName"
          placeholder="请选择所属组织"
          @focus="openOffice(1)"
        ></el-input> -->
        <el-button type="danger" @click="doSearch" style="margin-left: 24px">查找</el-button>
        <el-button type="info" @click="resetSearch" plain>重置</el-button>
      </div>

      <div class="equipListInfoShowContent">
        <div class="equipListInfoShow" v-for="(item, index) in dataList" :key="index">
          <div class="statusShow" :class="['statusShow_' + item.workStatus]"></div>
          <div class="warn" v-if="item.hasMaintenanceWarning">待保养</div>
          <!-- <div class="equipName"></div> -->
          <div class="equipNameText">{{ item.name }}-{{ item.code }}</div>

          <div class="equipImgShow equipImgShow_t" v-if="item.type == 27 || item.type == 28"></div>
          <div class="equipImgShow equipImgShow_d" v-if="item.type == 29 || item.type == 32"></div>
          <div class="equipImgShow equipImgShow_s" v-if="item.type == 30 || item.type == 33"></div>
          <div class="equipImgShow equipImgShow_l" v-if="item.type == 31 || item.type == 34"></div>
          <div class="equipImgShow equipImgShow_x" v-if="item.type == 35"></div>
          <div class="infoContent">
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">今日是否有报警</div>
                <div class="itemRight">
                  <span class="infoShow" v-if="item.warningToday == '无'">{{
                    item.warningToday
                  }}</span>
                  <span class="infoShow_warn" v-if="item.warningToday == '有'"
                    @click="goToEquipInfo(item.code, item.typeName, 3)">{{ item.warningToday }}</span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">昨日油耗</div>
                <div class="itemRight">
                  <span class="infoShow" v-if="item.hasWarningYesterdayOil == false">{{ item.yesterdayOil }}L</span>
                  <span class="infoShow_warn" v-if="item.hasWarningYesterdayOil == true"
                    @click="goToEquipInfo(item.code, item.typeName, 0)">{{ item.yesterdayOil }}L
                  </span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">今日油耗</div>
                <div class="itemRight">
                  <span class="infoShow" v-if="item.hasWarningTodayOil == false">{{ item.todayOil }}L
                  </span>
                  <span class="infoShow_warn" v-if="item.hasWarningTodayOil == true"
                    @click="goToEquipInfo(item.code, item.typeName, 0)">{{ item.todayOil }}L
                  </span>
                </div>

              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">昨日开机时长</div>
                <div class="itemRight">
                  <span class="infoShow" v-if="item.hasWarningYesterdayOnlineTime == false">{{ item.yesterdayOnlineTime
                  }}H</span>
                  <span class="infoShow_warn" v-if="item.hasWarningYesterdayOnlineTime == true"
                    @click="goToEquipInfo(item.code, item.typeName, 1)">{{ item.yesterdayOnlineTime }}H
                  </span>
                </div>
              </div>
              <div class="item_type1">
                <div class="itemLeft">今日开机时长</div>
                <div class="itemRight">
                  <span class="infoShow" v-if="item.hasWarningTodayOnlineTime == false">{{ item.todayOnlineTime }}H</span>
                  <span class="infoShow_warn" v-if="item.hasWarningTodayOnlineTime == true"
                    @click="goToEquipInfo(item.code, item.typeName, 1)">{{ item.todayOnlineTime }}H
                  </span>
                </div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">
                  最新位置
                  <div class="newPosition" @click="goToEquipmentMonitor(item.code)"></div>
                </div>

                <div class="itemRight">{{ item.address }}</div>
              </div>
            </div>
            <div class="blockItem">
              <div class="item_type1">
                <div class="itemLeft">最新上线记录</div>
                <div class="itemRight">{{ item.latestOnline }}</div>
              </div>
            </div>
          </div>
          <div class="lookMore" @click="toEquipmentInfo(item.code, item.typeName)">
            <span class="lookMoreText">查看更多</span>
          </div>
        </div>
      </div>

      <el-pageCover class="pageBlock" :pageMsg="pageMsg" @sizeChange="pageSizeChange"
        @currentChange="currentPageChange"></el-pageCover>
    </div>
    <el-dialog :title="actionNameT" :visible.sync="officeShow" :close-on-click-modal="false" width="400px"
      @selection-change="handleSelectionChange" :row-key="fieldKey">
      <div class="borderBlock borderPadding addAndEdit">
        <el-tree :data="treeList" node-key="id" ref="maskTree" default-expand-all accordion
          :filter-node-method="filterNode" :expand-on-click-node="false" @node-click="handleNodeClickAdd"
          :default-checked-keys="checkedKeys"></el-tree>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="officeShow = false">取消</el-button>
            <el-button type="primary" @click="editModSubmit">确定</el-button>
        </span> -->
    </el-dialog>
  </div>
</template>

<script>
import {
  getEquipTypeList,
  getEquipDigitalManageEquipList as fetchDtList,
  getOfficeList,
} from "../../utils/api";
import roleMixin from "../../utils/roleMixin";
import mixinList from "../../utils/mixinList";
import ElPageCover from "../../components/overall/ElPageCover";
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {
    return {
      search: {},
      arrowList: [
        {
          name: "设备中心",
          path: "/transfer/equipmentCenter",
        },
        {
          name: "",
          path: "/transfer",
        },
      ],
      btnList: [
        // {
        //   name: "位置监控",
        //   key: "EquipmentMonitor",
        //   imgSrc: require("../../images/icon/equip_1.png"),
        // },
        {
          name: "设备数字化管理",
          key: "Digitization",
          imgSrc: require("../../images/icon/equip_2.png"),
        },
        // {
        //   name: "使用报告",
        //   key: "WordList",
        //   imgSrc: require("../../images/icon/equip_3.png"),
        // },
        {
          name: "基础管理",
          key: "EquipmentList",
          imgSrc: require("../../images/icon/equip_4.png"),
        },
        {
          name: "终端管理",
          key: "Entry",
          imgSrc: require("../../images/icon/equip_4.png"),
        },
        {
          name: "操作综合评估",
          key: "oesAnalysis",
          imgSrc: require("../../images/icon/c_3.png"),
        },

      ],
      equipTypeList: [],
      equipStatusList: [
        {
          id: "",
          name: "全部",
        },
        {
          id: 0,
          name: "离线",
        },
        {
          id: 1,
          name: "怠速",
        },
        {
          id: 2,
          name: "作业中",
        },
      ],
      errorList: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: 1,
          name: "异常设备",
        },
        {
          id: 2,
          name: "无异常设备",
        },
      ],
      pageMsg: {
        pageSize: 10,
        pageNo: 1,
        totalRecords: 0,
      },
      loading: "",
      treeList: [],
      actionNameT: "",
      officeShow: false,
      officeSetType: "",
      formShow: "",
      fieldKey: "ids",
      checkedKeys: [],
    };
  },
  computed: {},
  created() { },
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    getEquipTypeList({ pageSize: 100 }).then((res) => {
      let allVal = {
        id: "",
        name: "全部",
      };
      this.equipTypeList = res.data.content.list;
      this.equipTypeList.unshift(allVal);
    });

    this.doSearch();
    getOfficeList(this.search).then((res) => {
      //console.log(res)
      let _arr = res.data.content.concat([]);

      let _getDepts = function (list, _depts) {
        for (let i = 0; i < list.length; i++) {
          let _m = list[i];
          _depts.push({
            id: _m.officeCode,
            label: _m.officeName,
            originalData: _m,
          });

          if (
            Object.prototype.hasOwnProperty.call(_m, "children") &&
            _m.children.length > 0
          ) {
            _depts[_depts.length - 1].children = [];
            _getDepts(_m.children, _depts[_depts.length - 1].children);
          }
        }
      };
      let _depts = [];
      _getDepts(_arr, _depts);
      this.treeList = _depts;
    });
  },
  methods: {
    fetchDtList,
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    doSearch: function () {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        // background: "rgba(0, 0, 0, 0.7)",
        target: document.querySelector(".centerBottom"),
      });
      this.getDataList(this.search, { listKey: "list" });
    },
    // 跳转到设备详情
    goToEquipInfo(code, type, tab) {
      this.$router.push({
        name: 'EquipmentInfo', params: {
          'code': code,
          'typeName': type,
          'inArrow': 'equipmentList',
          'index': tab
        }
      })
    },
    goToEquipmentMonitor(code) {
      this.$router.push({
        name: 'EquipmentMonitor', params: {
          'code': code,
        }
      })
    },
    gotoOther: function (e) {
      if (e == "oesAnalysis") {
        window.open('https://ljszh.test.rootcloudapp.com/oes/#/')
      } else {
        this.$router.push({ name: e });
      }

    },
    toEquipmentInfo: function (c, t) {
      this.$router.push({
        name: "EquipmentInfo",
        params: {
          code: c,
          typeName: t,
          inArrow: "equipmentCenter",
        },
      });
    },
    openOffice: function (val) {
      //console.log('111')
      this.actionNameT = "部门选择";
      this.officeShow = true;
      this.officeSetType = val;
      this.formShow = false;
      this.formShow = true;
    },
    handleSelectionChange: function (val) {
      let deleteArr = [];
      for (let i = 0; i < val.length; i++) {
        deleteArr.push(val[i].id);
      }
      this.deleteStr = deleteArr.join(",");
    },
    handleNodeClickAdd(val) {
      //console.log(val)
      var that = this;
      if (this.officeSetType == 1) {
        that.search.officeCode = val.id;
        that.search.officeName = val.label;
      } else {
        // that.officeCode = val.id;
        // that.officeName = val.label;

        that.modelObj.officeName = val.label;
        that.modelObj.officeCode = val.id;
        that.mediaName = "";
        let timer = setTimeout(function () {
          that.$set(that.modelObj, "officeName", val.label + " ");
          that.$set(that.modelObj, "officeCode", val.id + " ");
          clearTimeout(timer);
          // that.officeCode = val.id;
          // that.officeName = val.label;

          // that.modelObj.officeName = val.label;
          // that.modelObj.officeCode = val.id;
        }, 300);
      }
      this.officeShow = false;
      // this.formShow=false;
      // this.formShow=true;
    },
  },
  components: {
    ElPageCover,
  },
};
</script>
<style lang="scss">
.equipSearchContent {
  .el-input {
    width: 180px !important;
    height: 36px !important;
    margin-left: 23px;
    // margin-right: 23px;
    font-size: 14px !important;

    .el-input__inner {
      width: 180px !important;
      height: 36px !important;
      border-radius: 1px !important;
    }
  }
}
</style>
<style lang="scss" scoped="">
.centerCon {
  min-height: 500px;
  width: 1872px;
  border-radius: 2px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  margin: 0 auto;

  .centerTop {
    width: 100%;
    height: 218px;
    position: relative;
    padding: 74px 0 0 0;
    border-bottom: 1px solid #f0f0f0;

    .line {
      height: 18px;
      width: 4px;
      background-color: #f56c6c;
      position: absolute;
      top: 28px;
      left: 24px;
    }

    .lineText {
      height: 26px;
      line-height: 26px;
      font-size: 18px;
      color: #404040;
      position: absolute;
      top: 24px;
      left: 36px;
      font-weight: medium;
    }

    .btnCon {
      width: 128px;
      height: 144px;
      float: left;
      margin-right: 32px;

      .imgCon {
        width: 80px;
        height: 80px;
        border-radius: 4px;
        background: rgba(245, 108, 108, 0.8);
        margin: 0 auto;
        cursor: pointer;

        .imgShow {
          width: 32px;
          height: 32px;
          margin: 24px 24px;
        }
      }
    }

    .btnText {
      height: 24px;
      line-height: 24px;
      width: 100%;
      margin-top: 16px;
      text-align: center;
      font-size: 16px;
      color: #404040;
      cursor: pointer;
    }
  }

  .centerBottom {
    width: 100%;
    min-height: 300px;
    position: relative;
    padding-top: 70px;
    padding-bottom: 24px;

    .line {
      height: 18px;
      width: 4px;
      background-color: #f56c6c;
      position: absolute;
      top: 28px;
      left: 24px;
    }

    .lineText {
      height: 26px;
      line-height: 26px;
      font-size: 18px;
      color: #404040;
      position: absolute;
      top: 24px;
      left: 36px;
      font-weight: medium;
    }

    .equipSearchContent {
      height: 40px;
      width: 100%;
      margin: 0 auto;
      background-color: #ffffff;

      // padding-top: 12px;
      .searchInputText {
        color: #595959;
        font-size: 14px;
        margin-left: 24px;
      }
    }

    .equipListInfoShowContent {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;

      .equipListInfoShow {
        width: 900px;
        height: 220px;
        margin-left: 24px;
        margin-top: 24px;
        background-color: #ffffff;
        position: relative;
        overflow: hidden;
        border: 1px solid #f0f0f0;

        .statusShow {
          height: 28px;
          width: 70px;
          // background: rgba(0,0,0,0.1);
          position: absolute;
          left: 0px;
          top: 0;
        }

        .statusShow_0 {
          background-image: url("../../images/all/eq_0.png");
        }

        .statusShow_1 {
          background-image: url("../../images/all/eq_1.png");
        }

        .statusShow_2 {
          background-image: url("../../images/all/eq_2.png");
        }

        .warn {
          width: 70px;
          height: 22px;
          background: #ff9900;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 22px;
          margin-left: 10px;
          margin-right: 10px;
          text-align: center;
          padding: 0 8px;
          position: absolute;
          left: 204px;
          top: 0;
        }

        .equipImgShow {
          height: 128px;
          width: 240px;
          position: absolute;
          top: 26px;
          left: 30px;
          background-size: 100% 100%;
          // z-index: 1;
        }

        .equipImgShow_t {
          background-image: url("../../images/car/t.png");
        }

        .equipImgShow_s {
          background-image: url("../../images/car/s.png");
        }

        .equipImgShow_l {
          background-image: url("../../images/car/l.png");
        }

        .equipImgShow_d {
          background-image: url("../../images/car/d.png");
        }

        .equipImgShow_x {
          background-image: url("../../images/car/x.png");
          background-size: 100% 80%;
          background-position-y: center;
          background-repeat: no-repeat;
        }

        .generateLMoreContent {
          position: absolute;
          height: 29px;
          width: 400px;
          bottom: 0;
          right: 10px;
          overflow: hidden;

          .generate {
            // position: absolute;
            height: 29px;
            width: 152px;
            float: right;
            // bottom: 0;
            // right: 121px;
            background: #e96c5a;
            transform: skewX(-20deg);
          }

          .LMore {
            // position: absolute;
            height: 29px;
            width: 160px;
            float: right;
            // bottom: 0;
            // right: -8px;
            background: #f2af4a;
            transform: skewX(-20deg);
            z-index: 100;
            margin-right: -8px;
          }
        }

        .generateLMoreTextContent {
          position: absolute;
          height: 29px;
          width: 400px;
          bottom: 0;
          right: 10px;
          overflow: hidden;

          .generate_text {
            // position: absolute;
            height: 29px;
            width: 152px;
            // bottom: 0;
            // right: 10px;
            color: #ffffff;
            font-size: 15px;
            line-height: 29px;
            // padding-left: 19px;
            cursor: pointer;
            float: right;
            text-align: center;
          }

          .LMore_text {
            // position: absolute;
            height: 29px;
            width: 160px;
            // bottom: 0;
            // right: -8px;
            color: #ffffff;
            font-size: 15px;
            line-height: 29px;
            // padding-left: 45px;
            cursor: pointer;
            z-index: 101;
            float: right;
            text-align: center;
          }
        }

        .equipName {
          height: 28px;
          line-height: 28px;
          width: 240px;
          text-align: center;
          background: #f56c6c;
          // border-radius: 20px 0px 20px 0px;
          position: absolute;
          left: 22px;
          bottom: 12px;
          z-index: 100;
          color: #ffffff;
          font-size: 16px;

          -webkit-transform: skew(-20deg);
          -moz-transform: skew(-20deg);
          -o-transform: skew(-20deg);
          -ms-transform: skew(-20deg);
          transform: skew(-20deg);
        }

        .equipNameText {
          width: 300px;
          height: 44px;
          line-height: 44px;
          text-align: center;
          position: absolute;
          background: #fef0f0;
          border: 1px solid #fde2e2;
          left: 0px;
          bottom: 0px;
          z-index: 100;
          color: #f56c6c;
          font-size: 14px;
        }

        .infoContent {
          height: 220px;
          width: 560px;
          position: absolute;
          top: 0px;
          left: 300px;
          border-right: 1px solid #f0f0f0;

          // border-top: 1px solid rgba(225, 225, 225, 1);
          // border-left: 1px solid rgba(225, 225, 225, 1);
          .blockItem {
            height: 44px;
            display: flex;

            .item_type1 {
              width: 100%;
              flex: 1;
              display: flex;
            }

            .itemLeft {
              flex: 1;
              height: 44px;
              float: left;
              background: #f5f5f5;
              border-bottom: 1px solid #f0f0f0;
              // border-right: 1px solid rgba(225, 225, 225, 1);
              line-height: 44px;
              padding-left: 15px;
              color: #8c8c8c;
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              position: relative;
            }

            .newPosition {
              background-image: url("../../images/icon/position.png");
              background-size: 100% 100%;
              width: 17.5px;
              height: 17.5px;
              position: absolute;
              top: 13px;
              left: 80px;
              cursor: pointer;
            }

            .itemRight {
              // width: 100%;
              flex: 1;
              // height: 40px;
              line-height: 44px;
              padding-left: 10px;
              color: #595959;
              font-size: 14px;

              overflow: hidden;
              border-bottom: 1px solid #f0f0f0;
              // border-right: 1px solid rgba(225, 225, 225, 1);
              position: relative;

              .infoShow {
                width: 100%;
                height: 100%;
                border: 0;
                color: #555555;
                font-size: 14px;
              }

              .infoShow_warn {
                display: inline-block;
                width: 120px;
                height: 24px;
                line-height: 24px;
                position: absolute;
                top: 10px;
                left: 10px;
                color: #ffffff;
                text-align: center;
                background: #f56c6c;
                border-radius: 3px;
                font-size: 14px;
                cursor: pointer;
              }
            }
          }
        }

        .lookMore {
          width: 40px;
          height: 220px;
          position: absolute;
          top: 0;
          right: 0;
          // line-height: 160px;
          text-align: center;
          background: #f56c6c;
          cursor: pointer;

          // padding: 5px;
          .lookMoreText {
            display: inline-block;
            position: absolute;
            -webkit-writing-mode: vertical-rl;
            writing-mode: vertical-rl;
            letter-spacing: 5px;
            vertical-align: middle;
            color: #ffffff;
            font-size: 14px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}

.pageBlock {
  margin-top: 30px;
}
</style>